import React from 'react';
import PageHeaderText from 'components/base/page-header-text';
import { Outlet } from 'react-router-dom';

const NewMealCategoryContent = () => {
  return (
    <div>
      <PageHeaderText
        title='Create New Meal Category'
        description='Ensure you provide correct details.'
      />
      <Outlet />
    </div>
  );
};

export default NewMealCategoryContent;
